import { DarwinFlex } from '../../Flex';
import { useTranslation } from 'react-i18next';
import { SearchBox } from '../../SearchBox';
import DarwinTypography from '../../Typography';
import { ListViewHeaderProps } from '../types';
import styles from './index.module.css';

const ListViewHeader = ({
  title,
  setSearchQuery,
  searchPlaceholder,
  actions,
  placeholderWidth = 400,
}: ListViewHeaderProps) => {
  const { t } = useTranslation();
  return (
    <DarwinFlex align="center" className={styles.tableHeader}>
      {title && (
        <DarwinTypography.Text className={styles.title}>
          {title}
        </DarwinTypography.Text>
      )}

      {setSearchQuery && (
        <div className={styles.searchBox}>
          <SearchBox
            style={{ maxWidth: placeholderWidth }}
            placeholder={searchPlaceholder || t('search')}
            onSearch={query => setSearchQuery(query)}
          />
        </div>
      )}

      {actions && (
        <DarwinFlex gap={12} align="center" className={styles.headerActions}>
          {actions}
        </DarwinFlex>
      )}
    </DarwinFlex>
  );
};

export default ListViewHeader;
